import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { RecordedSave } from "@/admin/Recorded";
import { AdminTitle } from "@/admin/AdminLayout";
import { inputCls } from "@/components/common";
import { Switch } from "@/components/ui/switch";

const NAMES: any = { afterpay: "Afterpay", zip: "Zip" };

function Provider({ k, v, set }: any) {
  return (
    <div className="border border-neutral-200 bg-white p-5 space-y-4" data-testid={`instalments-${k}`}>
      <div className="flex items-center justify-between">
        <label className="flex items-center gap-3 text-sm font-medium"><Switch checked={v.enabled} onCheckedChange={(x: boolean) => set({ ...v, enabled: x })} data-testid={`instalments-${k}-switch`} />{NAMES[k]}</label>
        <span className={`text-[11px] uppercase tracking-wider ${v.live ? "text-green-700" : "text-amber-700"}`} data-testid={`instalments-${k}-mode`}>{v.live ? "Live keys added" : "Test mode · admins only"}</span>
      </div>
      <div className="grid grid-cols-2 gap-3 text-xs text-neutral-500">
        <label>Minimum order (AUD)<input type="number" min={0} value={v.min} onChange={(e) => set({ ...v, min: Number(e.target.value) })} className={`${inputCls} mt-1`} data-testid={`instalments-${k}-min`} /></label>
        <label>Maximum order (AUD)<input type="number" min={1} value={v.max} onChange={(e) => set({ ...v, max: Number(e.target.value) })} className={`${inputCls} mt-1`} data-testid={`instalments-${k}-max`} /></label>
      </div>
      {!v.live && <p className="text-xs text-neutral-500">Until your {NAMES[k]} merchant keys are added, only signed-in admins see this option and its price messages, and test payments don't move money.</p>}
    </div>
  );
}

export default function AdminInstalments() {
  const [d, setD] = useState<any>(null);
  useEffect(() => { api.get("/admin-x/instalments").then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  const save = async () => {
    try { const r = await api.put("/admin-x/instalments", { afterpay: d.afterpay, zip: d.zip }); setD(r.data); toast("Instalment settings saved"); return true; } catch (e) { toast.error(errMsg(e)); return false; }
  };
  return (
    <div data-testid="admin-instalments">
      <AdminTitle title="Pay in Instalments" sub="Afterpay and Zip at checkout, plus the “4 payments of…” line on product pages and the bag.">{d && <RecordedSave res="settings" id="instalments" onSave={save} value={{ a: d.afterpay, z: d.zip }} testId="instalments-save" onRestored={() => api.get("/admin-x/instalments").then((r) => setD(r.data))} />}</AdminTitle>
      {d && <div className="space-y-3 max-w-2xl">{["afterpay", "zip"].map((k) => <Provider key={k} k={k} v={d[k]} set={(v: any) => setD({ ...d, [k]: v })} />)}</div>}
    </div>
  );
}
